namespace GeniuzPOS.Purchase {
    export class ReportDailyPIColumns {
        static columnsKey = 'Purchase.ReportDailyPI';
    }
}
